import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { AsyncPipe } from '@angular/common';
import { ButtonDirective } from '../../ui/button.directive';
import { IconComponent } from '../../ui/icon.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  imports: [AsyncPipe, ButtonDirective, IconComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class HomeComponent {
  protected readonly sellingPoints = [
    'Toffe lesgevers',
    'Vette muziek',
    'Lessen voor elk niveau',
  ];

  // Guests get a proefles call-to-action; signed-in users don't need it.
  userLoggedIn$: Observable<boolean> = this.authService.userLoggedIn$;

  constructor(
    public router: Router,
    private authService: AuthService,
  ) {}

  navigateToReservePage() {
    this.router.navigateByUrl('/reserveer');
  }

  navigateToInfoPage() {
    this.router.navigateByUrl('/info#uren');
  }

  navigateToProeflesPage() {
    this.router.navigateByUrl('/proefles');
  }
}
